module.exports = __webpack_public_path__ + "static/media/monkeyisland1.138488b8.gif";